"use strict";

/******
MODAL
*******/
function closeModal(id) {
  var modal = document.getElementById(id),
      iframe = modal.querySelector('iframe');
  iframe.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  modal.classList.remove('is-open');
}